export default __webpack_public_path__ + "static/media/tvs-ntorq.26b66332.svg";